import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import debounce from 'lodash-decorators/debounce';

import PaymentEvents from 'shared/components/payment-events/payment-events';
import {
  clearVideoUrlsCacheForAll,
  clearVideoUrlsCacheForItem,
} from 'widget/redux/client/actions/video-urls/clear';

@connect(
  null,
  {
    clearVideoUrlsCacheForAll,
    clearVideoUrlsCacheForItem,
  },
)
export default class ClearVideoUrlsCacheOnPayment extends React.Component {
  static propTypes = {
    clearVideoUrlsCacheForAll: PropTypes.func,
    clearVideoUrlsCacheForItem: PropTypes.func,
  };

  @debounce(300)
  clearVideoUrlsCacheForAll = () => {
    this.props.clearVideoUrlsCacheForAll();
  };

  clearVideoUrlsCacheForItem = data => {
    this.props.clearVideoUrlsCacheForItem(data.itemId);
  };

  render() {
    return (
      <PaymentEvents
        onSubscription={this.clearVideoUrlsCacheForAll}
        onSubscriptionCancel={this.clearVideoUrlsCacheForAll}
        onRent={this.clearVideoUrlsCacheForItem}
        onSale={this.clearVideoUrlsCacheForItem}
      />
    );
  }
}
